import { atom } from "jotai"
import { atomWithStorage } from "jotai/utils"
import { fallbackLng } from "@/lib/i18n/settings"

// 当前语言 atom - 自动持久化到localStorage
export const currentLanguageAtom = atomWithStorage<string>(
	"current_language",
	fallbackLng,
	undefined,
	{ getOnInit: true },
)

// 可用语言列表 atom
export const availableLanguagesAtom = atom<string[]>([])

// 当前地区 atom
export const currentAreaAtom = atom<string>("")

// 语言状态管理 atom - 组合了所有语言相关的状态
export const languageStateAtom = atom(
	(get) => {
		const currentLanguage = get(currentLanguageAtom)
		const availableLanguages = get(availableLanguagesAtom)
		const currentArea = get(currentAreaAtom)

		return {
			currentLanguage,
			availableLanguages,
			currentArea,
		}
	},
	(
		get,
		set,
		update: {
			currentLanguage?: string
			availableLanguages?: string[]
			currentArea?: string
		},
	) => {
		if (update.currentLanguage !== undefined) {
			// 由于 currentLanguageAtom 是 atomWithStorage，set 时需要兼容 jotai 的 SetStateActionWithReset 类型
			set(currentLanguageAtom, update.currentLanguage as any)
		}
		if (update.availableLanguages !== undefined) {
			set(availableLanguagesAtom, update.availableLanguages)
		}
		if (update.currentArea !== undefined) {
			set(currentAreaAtom, update.currentArea)
		}
	},
)
